const companyName = "Dothouz";

export {companyName}; 